// DataTags
// The datatag regex match is mainly \{\[[^\{\[\]\}]*\]\} to detect any text wrapped in "{[ ]}".
// The negative lookahead before it is repeating parts of it multiple times to detect any HTML tags,
// which we want to exclude from datatag matching.
// NOTE: For bundle size concerns, this regex is currently mirrored in nucleus-core/imagegallery/Item.js and
// @cvent/carina-datatag-selector/src/DatatagSelector/constants.js. Any updates to this regex should be propagated
// in those packages as well.
// eslint-disable-next-line max-len
var DATA_TAG_REG_EXP = /(?!\{\[[^\{\[\]\}]*<[^\{\[\]\}]*>[^\{\[\]\}]*\]\})\{\[[^\{\[\]\}]*\]\}/g;

export default DATA_TAG_REG_EXP;
export { DATA_TAG_REG_EXP };
//# sourceMappingURL=index.js.map
